import React, {useMemo} from 'react'
import WizImage from '@component/images/WizImage'
import ic_default_user from '@image/ic_default_user.webp'
import ic_default_user_dark from '@image/ic_default_user_dark.webp'
import useDark from '@hook/useDark'
import {DarkModeStore} from '@store/DarkmodeStore'

const NETWORK_ICONS = {
    google: require('../../../public/images/login/ic_google.png'),
    gmail: require('../../../public/images/login/ic_google.png'),
    facebook: require('../../../public/images/login/ic_facebook.png'),
    coinbase: require('../../../public/images/login/ic_coinbase.png'),
    apple: require('../../../public/images/login/ic_apple.png'),
    kakaotalk: require('../../../public/images/login/ic_kakao.png'),
    binance: require('../../../public/images/login/ic_binance.png'),
    okx: require('../../../public/images/login/ic_okx.png'),
    email: require('../../../public/images/login/ic_network.png'),
}

interface IProps {
    src: any
    imageClassName?: string
    containerClassName?: string
    size?: number
    isPro?: boolean
    isMe?: boolean
    network?: string
    unoptimized?: boolean
}

const UserThumbnail: React.FC<IProps> = ({
    src,
    imageClassName,
    containerClassName,
    size,
    isPro = false,
    isMe,
    network,
    unoptimized,
}) => {
    const {isRenderDark} = useDark()
    const {isCheckDark} = DarkModeStore()
    const imageSize = useMemo(() => {
        if (isPro) {
            if (size > 50) return size - 8
            else return size - 4
        } else return size
    }, [size, isPro])

    const proContainerClassName = useMemo(() => {
        if (isPro) {
            if (size > 50) return 'border border-[2px] p-[2px] border-font_pro'
            else return 'border border-[1px] p-[1px] border-font_pro'
        } else return ''
    }, [isPro, size])
    return (
        <div className={`relative rounded-full flex-none ${proContainerClassName} ${containerClassName}`}>
            <WizImage
                src={src}
                containerClassName={`flex-none`}
                imageClassName={`${imageClassName} rounded-full`}
                width={imageSize}
                height={imageSize}
                placeHolder={isRenderDark && isCheckDark ? ic_default_user_dark : ic_default_user}
                unoptimized={unoptimized}
            />

            {network && (
                <div className={'absolute -right-0.5 -bottom-0.5 bg-white w-[21px] h-[21px] rounded-full'}>
                    <WizImage src={NETWORK_ICONS[network]} width={20} height={20} />
                </div>
            )}
        </div>
    )
}

export default React.memo(UserThumbnail)
